import React, { Component } from 'react';

class Footer extends Component {
  render() {
    return (
      <footer className="app-footer">
        <a href="#/">SEM / Display Dashboard</a> &copy; Kicking Panda!
        <span className="float-right">Powered by Google App Engine / React Core UI</span>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js